import { Component, OnInit, ViewChild, HostBinding } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { DrawerService } from './_shared/services/drawer.service';
import { MobileMenuService } from './_shared/services/mobile-menu.service';
import {
    NavigationEnd,
    NavigationError,
    Router,
    RouterOutlet,
} from '@angular/router';
import { environment } from '../environments/environment';
import { DataLayerService } from './_shared/services/data-layer.service';
import { FullscreenService } from './_shared/services/fullscreen.service';
import { VersionCheckService } from './_shared/services/version-check.service';
import { PortalModule } from '@angular/cdk/portal';
import { AsyncPipe } from '@angular/common';

// used across the app for echo/push notifications
declare global {
    interface Window {
        Ably: any;
        Echo: any;
    }
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [MatSidenavModule, PortalModule, RouterOutlet, AsyncPipe],
    standalone: true,
})
export class AppComponent implements OnInit {
    title = 'DoorSpot';
    events: string[] = [];
    opened = false;

    @ViewChild('rightDrawer', { static: true }) rightDrawer!: MatSidenav;
    @ViewChild('leftDrawer', { static: true }) leftDrawer!: MatSidenav;

    // Bind fullscreen state to the app-root host element
    @HostBinding('class.fullscreen-mode')
    get isFullscreen() {
        return this.fullscreenService.isFullscreen();
    }

    constructor(
        public drawerService: DrawerService,
        public mobileDrawerService: MobileMenuService,
        public router: Router,
        private dataLayerService: DataLayerService,
        private fullscreenService: FullscreenService,
        private versionCheckService: VersionCheckService,
    ) {}

    /** The drawers live here but can be opened/closed from all 3 child layouts */
    ngOnInit() {
        this.drawerService.drawer = this.rightDrawer;
        this.mobileDrawerService.menuDrawer = this.leftDrawer;

        // Initialize version checking for cache busting
        this.versionCheckService.initVersionCheck();

        // Redirect URLs where query separator '?' was percent-encoded as '%3F' in the path,
        // which causes Angular Router to fail matching (NG04002). Decode and retry navigation.
        this.router.events.subscribe((event) => {
            if (
                event instanceof NavigationError &&
                (event.url.includes('%3F') || event.url.includes('%3f'))
            ) {
                try {
                    void this.router.navigateByUrl(
                        decodeURIComponent(event.url),
                    );
                } catch {
                    // malformed percent-sequence — leave the navigation error as-is
                }
            }
        });

        if (environment.production) {
            this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.dataLayerService.logPageView(event.urlAfterRedirects);
                }
            });
        }

        // TODO decide if we need to use this to clean things up when state changes
        // echo.connector.ably.connection.on((stateChange:any) => {
        //     if (stateChange.current === 'disconnected' && stateChange.reason?.code === 40142) { // key/token status expired
        //         console.log("LOGGER:: Connection token expired https://help.ably.io/error/40142");
        //     }
        // });
    }
}
